import { isModuleEntity } from "@client/lib/layout";
import { addVersion, getResponsiveValue, setResponsiveValue } from "@client/lib/settings";
import { getModuleDefaultSettings } from "@client/settings/module";
import { type Entities, type MainSettings } from "@client/types";
import { compareVersionNumbers } from ".";

export const version = "04.00.01";
export const upgradeEntities = (entities: Entities, settings: MainSettings | null): Entities => {
  Object.values(entities).forEach((x) => {
    if (!x.settings || compareVersionNumbers(x.settings.version, version) >= 0) return;

    if (isModuleEntity(x)) {
      switch (x.moduleType) {
        case "CourseDetail": {
          const ds = getModuleDefaultSettings(x.moduleType);
          x.settings = setResponsiveValue(x.settings, "button", getResponsiveValue(ds, "button"));
          x.settings = setResponsiveValue(x.settings, "secondaryButton", getResponsiveValue(ds, "secondaryButton"));
          break;
        }
        case "CourseList":
        case "MemberRecurringOrders": {
          const ds = getModuleDefaultSettings(x.moduleType);
          x.settings = setResponsiveValue(x.settings, "secondaryButton", getResponsiveValue(ds, "secondaryButton"));
          break;
        }
        case "Spacer": {
          x.settings = setResponsiveValue(x.settings, "animation", undefined);
          break;
        }
      }
    }

    x.settings = addVersion(x.settings, version);
  });

  return entities;
};

export const upgradeSettings = (settings: MainSettings) => settings;
